/**
 * 自动监测的传感器分类定义
 */
const AutoConfig = [{
    Resource: 125,
    Alias: '温度20CM深度',
    Category: '自动监测',
    Group: 'temperature',
    Installed: false,
    DataType: 'time'
}, {
    Resource: 126,
    Alias: '湿度20CM深度',
    Category: '自动监测',
    Group: 'humidity',
    Installed: false,
    DataType: 'time'
}, {
    Resource: 129,
    Alias: '电导率20CM深度',
    Category: '自动监测',
    Group: 'conductivity',
    Installed: false,
    DataType: 'time'
}, {
    Resource: 128,
    Alias: '盐分20CM深度',
    Category: '自动监测',
    Group: 'salinity',
    Installed: false,
    DataType: 'time'
}, {
    Resource: 152,
    Alias: '温度40CM深度',
    Category: '自动监测',
    Group: 'temperature',
    Installed: false,
    DataType: 'time'
}, {
    Resource: 153,
    Alias: '湿度40CM深度',
    Category: '自动监测',
    Group: 'humidity',
    Installed: false,
    DataType: 'time'
}, {
    Resource: 156,
    Alias: '电导率40CM深度',
    Category: '自动监测',
    Group: 'conductivity',
    Installed: false,
    DataType: 'time'
}, {
    Resource: 157,
    Alias: '温度60CM深度',
    Category: '自动监测',
    Group: 'temperature',
    Installed: false,
    DataType: 'time'
}, {
    Resource: 158,
    Alias: '湿度60CM深度',
    Category: '自动监测',
    Group: 'humidity',
    Installed: false,
    DataType: 'time'
}, {
    Resource: 162,
    Alias: '温度80CM深度',
    Category: '自动监测',
    Group: 'temperature',
    Installed: false,
    DataType: 'time'
}, {
    Resource: 163,
    Alias: '湿度80CM深度',
    Category: '自动监测',
    Group: 'humidity',
    Installed: false,
    DataType: 'time'
}]
/**
 * 人工检测分类定义
 */
const MauConfig = [{
        Resource: 127,
        Alias: '土壤pH值',
        Category: '移动监测',
        Installed: false,
        DataType: 'space'
    }, {
        Resource: 141,
        Alias: '土壤容重',
        Category: '人工检测',
        Installed: false,
        DataType: 'space'
    },
    //  {
    //     Resource: 130,
    //     Alias: '土壤紧实度',
    //     Category: '人工检测',
    //     Installed: false,
    //     DataType: 'space'
    // }, {
    //     Resource: 137,
    //     Alias: '水稳定团聚体',
    //     Category: '人工检测',
    //     Installed: false,
    //     DataType: 'space'
    // },
    {
        Resource: 137,
        Alias: '有机质含量',
        Category: '人工检测',
        Installed: false,
        DataType: 'space'
    }, {
        Resource: 138,
        Alias: '全氮',
        Category: '人工检测',
        Installed: false,
        DataType: 'space'
    }, {
        Resource: 139,
        Alias: '有效磷',
        Category: '人工检测',
        Installed: false,
        DataType: 'space'
    }, {
        Resource: 140,
        Alias: '速效钾',
        Category: '人工检测',
        Installed: false,
        DataType: 'space'
    }
]

export default {
    AutoConfig,
    MauConfig
}
